// extracted by mini-css-extract-plugin
export default {"dialog":"AiAgentConfigDialog_dialog__zjQ+i"};